import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./styles.css";
import { Layout } from "./components/Layout.tsx";
import { LoadingState } from "./components/UI.tsx";

const Home = lazy(() => import("./pages/Home.tsx"));
const Services = lazy(() => import("./pages/Services.tsx"));
const ServiceDetail = lazy(() => import("./pages/ServiceDetail.tsx"));
const About = lazy(() => import("./pages/About.tsx"));
const Sustainability = lazy(() => import("./pages/Sustainability.tsx"));
const HowItWorks = lazy(() => import("./pages/HowItWorks.tsx"));
const Quote = lazy(() => import("./pages/Quote.tsx"));
const Contact = lazy(() => import("./pages/Contact.tsx"));
const FAQ = lazy(() => import("./pages/FAQ.tsx"));
const Blog = lazy(() => import("./pages/Blog.tsx"));
const Legal = lazy(() => import("./pages/Legal.tsx"));
const Login = lazy(() => import("./pages/admin/Login.tsx"));
const Dashboard = lazy(() => import("./pages/admin/Dashboard.tsx"));
const AdminLeads = lazy(() => import("./pages/admin/AdminLeads.tsx"));
const AdminMessages = lazy(() => import("./pages/admin/AdminMessages.tsx"));

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Suspense fallback={<LoadingState label="Loading Renza" />}>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home locale="da" />} />
              <Route path="/en" element={<Home locale="en" />} />
              <Route path="/ydelser" element={<Services locale="da" />} />
              <Route path="/en/services" element={<Services locale="en" />} />
              <Route path="/om-os" element={<About locale="da" />} />
              <Route path="/en/about" element={<About locale="en" />} />
              <Route
                path="/baeredygtighed"
                element={<Sustainability locale="da" />}
              />
              <Route
                path="/en/sustainability"
                element={<Sustainability locale="en" />}
              />
              <Route
                path="/saadan-fungerer-det"
                element={<HowItWorks locale="da" />}
              />
              <Route
                path="/en/how-it-works"
                element={<HowItWorks locale="en" />}
              />
              <Route path="/faa-tilbud" element={<Quote locale="da" />} />
              <Route path="/en/request-quote" element={<Quote locale="en" />} />
              <Route path="/kontakt" element={<Contact locale="da" />} />
              <Route path="/en/contact" element={<Contact locale="en" />} />
              <Route path="/faq" element={<FAQ locale="da" />} />
              <Route path="/en/faq" element={<FAQ locale="en" />} />
              <Route path="/blog" element={<Blog locale="da" />} />
              <Route path="/en/blog" element={<Blog locale="en" />} />
              <Route
                path="/privatlivspolitik"
                element={<Legal locale="da" type="privacy" />}
              />
              <Route
                path="/cookiepolitik"
                element={<Legal locale="da" type="cookies" />}
              />
              <Route
                path="/en/privacy-policy"
                element={<Legal locale="en" type="privacy" />}
              />
              <Route
                path="/en/cookie-policy"
                element={<Legal locale="en" type="cookies" />}
              />
              <Route path="/:slug" element={<ServiceDetail locale="da" />} />
              <Route path="/en/:slug" element={<ServiceDetail locale="en" />} />
            </Route>
            <Route path="/admin" element={<Login />} />
            <Route path="/admin/dashboard" element={<Dashboard />} />
            <Route path="/admin/leads" element={<AdminLeads />} />
            <Route path="/admin/contact-messages" element={<AdminMessages />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
